// extracted by mini-css-extract-plugin
export default {"userNameRow":"NavigationAvatar_userNameRow__46DWV","navigationAvatarFooter":"NavigationAvatar_navigationAvatarFooter__ExksI","footerLink":"NavigationAvatar_footerLink__scJoi"};